const scrollTrackingOpts = {
    // Use 2 to force Classic Analytics hits and 1 for Universal hits
    forceSyntax: 1,
    // False if you just use the default dataLayer variable, otherwise enter it here
    dataLayerName: false,
    distances: {
        // Configure percentages of page you'd like to see if users scroll past
        percentages: {
            each: [],
            every: 25,
        },
        // Configure for pixel measurements of page you'd like to see if users scroll past
        pixels: {
            each: [],
            every: null,
        },
        // Configure elements you'd like to see users scroll past (using CSS Selectors)
        elements: {
            each: [],
            every: [],
        },
    },
    // Accepts a number, DOM element, or query selector to determine the top of the scrolling area
    top: null,
    // Accepts a number, DOM element, or query selector to determine the bottom of the scrolling area
    bottom: null,
    // Text for Event Category
    category: 'DL1: Scroll Depth',
    // Text for Event Label
    label: document.body.getAttribute('data-here'),
};

export default scrollTrackingOpts;